<script>
	import {
		Button,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";
	import { navigate } from "svelte-routing";
	import CustomSearch from "../../../components/CustomSearch/CustomSearch.svelte";
	import { loadVehicleOptions } from "src/services/vehicle";

	export let isOpen = false;
	export let toggle = () => {};

	let selectedVehicle = "";
	let searchWrapper;

	function focusSearchInput() {
		searchWrapper?.querySelector("input")?.focus();
	}

	function resetAndToggle() {
		selectedVehicle = "";
		toggle();
	}

	function handleNext() {
		navigate(
			`/maintenance-repair/${selectedVehicle.value}/issues/create-issue`
		);
		resetAndToggle();
	}
</script>

<Modal {isOpen} toggle={resetAndToggle} on:open={focusSearchInput} centered>
	<ModalHeader class="create-issue-modal-header"
		>Create an issue for a vehicle</ModalHeader
	>
	<ModalBody>
		<div class="vehicle-label">
			Search a vehicle to create an issue for<span class="required-marker"
				>*</span
			>
		</div>
		<div class="fds-dropdown-list" bind:this={searchWrapper}>
			<CustomSearch
				label="Search a vehicle to create an issue for"
				placeholder="Search for vehicle plate number"
				containerClasses="search-icon"
				bind:value={selectedVehicle}
				loadOptions={loadVehicleOptions}
			/>
		</div>
	</ModalBody>
	<ModalFooter>
		<Button class="themeButton backButton px-4" on:click={resetAndToggle}>
			Cancel
		</Button>
		<Button
			class="themeButton primary px-4"
			disabled={!selectedVehicle}
			on:click={handleNext}
		>
			Next
		</Button>
	</ModalFooter>
</Modal>

<style>
	:global(.create-issue-modal-header .modal-title) {
		font-size: 20px;
		font-weight: 700;
		line-height: 28px;
		color: var(--fds-on-surface-container, #00071f);
	}

	.vehicle-label {
		margin-bottom: 8px;
		line-height: 20px;
		color: var(--fds-on-surface, #00071f);
	}

	.vehicle-label + div :global(input) {
		font-size: 16px;
		line-height: 20px;
	}

	.required-marker {
		color: var(--fds-error, #d60c0c);
	}
</style>
